import React from 'react';

import Card from '../../../../../components/Card/index';

const RegistrationApproval = () => {
  return (
    <Card>
      <Card.Header>Pending Approval</Card.Header>
      <Card.Body>
        Thank you for submitting your registration. You will be notified once your application is either approved or
        rejected.
      </Card.Body>
    </Card>
  );
};

export default RegistrationApproval;
